import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteServiceAreaOverrideRule } from '../../../api/plan-service-area-override-rules-api'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'

export function useDeleteServiceAreaOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, string>({
    mutationFn: (id) => deleteServiceAreaOverrideRule(id),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
